import React, { useEffect } from 'react';
import { AlertBanner } from './components/AlertBanner';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { ValueStack } from './components/ValueStack';
import { ForWhom } from './components/ForWhom';
import { TransformationTimeline } from './components/TransformationTimeline';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream-50 font-body selection:bg-sage-200 selection:text-sage-900 overflow-x-hidden" data-id="element-0">
      <AlertBanner data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmotionalHook data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <MethodSection data-id="element-6" />
        <ValueStack data-id="element-7" />
        <ForWhom data-id="element-8" />
        <TransformationTimeline data-id="element-9" />
        <FAQSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <PricingSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}